/* ==========================================================================
 *  Dropdown toggle
 * ======================================================================= */
function fn_parts_dropdown(){
	if ($('.dropdown-toggle').length){
          $('.dropdown-toggle').on('click', function () {
	        $(this).closest('.dropdown').find('.dropdown-menu').stop().slideToggle('fast');
	    });
	}
}